module.exports = __webpack_public_path__ + "media/application/images/ui/icons-masthead-9a37eb46f041aded653a8ad01e25fa7a.png";